// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2TeW2","Open":"SideDrawer_Open__3ctvs","Close":"SideDrawer_Close__2ews2","Logo":"SideDrawer_Logo__3aV9D"};